import ReactMarkdown, { type Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface Props {
  source: string;
  /** Compact spacing for dense contexts (a queue row, a card). */
  tight?: boolean;
}

const components: Components = {
  a: ({ node: _node, ...props }) => <a {...props} target="_blank" rel="noreferrer" />,
};

/**
 * Standards-based CommonMark and GitHub-flavoured Markdown for untrusted ticket content.
 * Raw HTML is deliberately not enabled: react-markdown emits a React tree and its default
 * URL transform rejects unsafe protocols.
 */
export function Markdown({ source, tight = false }: Props) {
  return (
    <div className={`md${tight ? ' md-tight' : ''}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {source}
      </ReactMarkdown>
    </div>
  );
}
